import { Star, Quote } from "lucide-react";
import { TESTIMONIALS } from "@/components/landing/content";

export default function Testimonials() {
  // Duplicate for seamless marquee
  const row1 = TESTIMONIALS.slice(0, 5);
  const row2 = TESTIMONIALS.slice(5);
  const loop1 = [...row1, ...row1];
  const loop2 = [...row2, ...row2];

  return (
    <section
      id="reviews"
      data-testid="testimonials-section"
      className="relative py-24 md:py-32"
    >
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="flex flex-wrap items-end justify-between gap-6">
          <div className="max-w-2xl">
            <span className="inline-block text-xs uppercase tracking-[0.22em] font-semibold text-orange-600">
              Reviews
            </span>
            <h2
              data-testid="testimonials-heading"
              className="font-display mt-3 text-4xl md:text-5xl lg:text-6xl font-extrabold text-slate-900 leading-[1.05]"
            >
              Kentucky owners,{" "}
              <span className="brand-text-gradient">real results.</span>
            </h2>
          </div>
          <div className="flex items-center gap-2">
            <div className="flex">
              {[0, 1, 2, 3, 4].map((i) => (
                <Star
                  key={i}
                  size={20}
                  className="fill-orange-500 text-orange-500"
                />
              ))}
            </div>
            <span
              data-testid="testimonials-rating"
              className="font-display font-extrabold text-slate-900"
            >
              4.9 / 5
            </span>
            <span className="text-sm text-slate-500">from local owners</span>
          </div>
        </div>
      </div>

      <div className="mt-12 scroller-mask">
        <div className="scroller-track" data-testid="testimonial-row-1">
          {loop1.map((t, i) => (
            <Card key={`r1-${i}`} t={t} index={i} />
          ))}
        </div>
      </div>
      <div className="mt-6 scroller-mask">
        <div
          className="scroller-track"
          style={{ animationDirection: "reverse", animationDuration: "55s" }}
          data-testid="testimonial-row-2"
        >
          {loop2.map((t, i) => (
            <Card key={`r2-${i}`} t={t} index={i} accent />
          ))}
        </div>
      </div>
    </section>
  );
}

function Card({ t, index, accent }) {
  return (
    <figure
      data-testid={`testimonial-card-${index}`}
      className={`shrink-0 w-[320px] md:w-[380px] rounded-3xl border ${
        accent
          ? "bg-blue-700 text-white border-blue-700"
          : "bg-white border-slate-200"
      } p-6 md:p-7 shadow-[0_10px_30px_-20px_rgba(15,23,42,0.25)]`}
    >
      <div className="flex items-center justify-between">
        <Quote
          size={26}
          className={accent ? "text-orange-300" : "text-orange-500"}
        />
        <div className="flex">
          {[0, 1, 2, 3, 4].map((i) => (
            <Star
              key={i}
              size={14}
              className={
                accent
                  ? "fill-orange-300 text-orange-300"
                  : "fill-orange-500 text-orange-500"
              }
            />
          ))}
        </div>
      </div>
      <blockquote
        className={`mt-4 text-base md:text-lg leading-relaxed font-body ${
          accent ? "text-blue-50" : "text-slate-700"
        }`}
      >
        “{t.quote}”
      </blockquote>
      <figcaption className="mt-5 flex items-center gap-3">
        <span
          className={`inline-flex h-9 w-9 items-center justify-center rounded-full font-display font-extrabold ${
            accent ? "bg-white/15 text-white" : "bg-slate-900 text-white"
          }`}
        >
          {t.name.charAt(0)}
        </span>
        <span className="leading-tight">
          <span
            className={`block font-display font-extrabold ${
              accent ? "text-white" : "text-slate-900"
            }`}
          >
            {t.name}
          </span>
          <span
            className={`block text-xs ${
              accent ? "text-blue-200" : "text-slate-500"
            }`}
          >
            {t.role}
          </span>
        </span>
      </figcaption>
    </figure>
  );
}
